// we love lenis smooth scroll yippee
import Lenis from "lenis";

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

let activeInstance: Lenis | null = null;
let rafHandle = 0;

export function smoothOn(wrapper: Element | null, content: Element | null): void {
  smoothOff();
  if (reduced || !wrapper || !content) return;

  activeInstance = new Lenis({
    wrapper: wrapper as HTMLElement,
    content: content as HTMLElement,
    lerp: 0.12,
    smoothWheel: true,
    syncTouch: true,
    wheelMultiplier: 1,
  });

  const loop = (time: number) => {
    if (activeInstance) {
      activeInstance.raf(time);
      rafHandle = requestAnimationFrame(loop);
    }
  };
  rafHandle = requestAnimationFrame(loop);
}

export function smoothOff(): void {
  if (activeInstance) {
    activeInstance.destroy();
    activeInstance = null;
  }
  cancelAnimationFrame(rafHandle);
}
